var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "features__group",
      class: { "features__group--specs": _vm.specs },
    },
    [
      !_vm.specs
        ? _c(
            "div",
            { staticClass: "flex flex-wrap" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "w-12/12 px-gap accordion__features-title pl-[56px] flex flex-row items-center accordion--open pt-1",
                  class: _vm.length > 2 ? "md:w-3/12" : "md:w-4/12",
                },
                [
                  _vm.featureGroup.fields.description
                    ? _c(
                        "div",
                        { staticClass: "align-text-bottom relative" },
                        [
                          _c(
                            "svg",
                            _vm._g(
                              {
                                staticClass: "inline mr-1/4 relative",
                                class: _vm.featureGroup.fields.description
                                  ? "cursor-pointer"
                                  : "",
                                attrs: {
                                  width: "20",
                                  height: "20",
                                  viewBox: "0 0 20 20",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              _vm.featureGroup.fields.description
                                ? {
                                    mouseenter: () => (_vm.open = !_vm.open),
                                    mouseleave: () => (_vm.open = !_vm.open),
                                  }
                                : {}
                            ),
                            [
                              _c("path", {
                                attrs: {
                                  d: "M9.16663 14.1667H10.8333V9.16675H9.16663V14.1667ZM9.99996 1.66675C5.39996 1.66675 1.66663 5.40008 1.66663 10.0001C1.66663 14.6001 5.39996 18.3334 9.99996 18.3334C14.6 18.3334 18.3333 14.6001 18.3333 10.0001C18.3333 5.40008 14.6 1.66675 9.99996 1.66675ZM9.99996 16.6667C6.32496 16.6667 3.33329 13.6751 3.33329 10.0001C3.33329 6.32508 6.32496 3.33341 9.99996 3.33341C13.675 3.33341 16.6666 6.32508 16.6666 10.0001C16.6666 13.6751 13.675 16.6667 9.99996 16.6667ZM9.16663 7.50008H10.8333V5.83342H9.16663V7.50008Z",
                                  fill: "#00263E",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("Tooltip", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.open === true,
                                expression: "open === true",
                              },
                            ],
                            attrs: {
                              content: _vm.get(
                                _vm.featureGroup,
                                "fields.description",
                                ""
                              ),
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mb-1/2 text-blue-dark font-bold" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.get(_vm.featureGroup, "fields.groupLabel", false)
                        ) +
                        "\n      "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.product, function (feature, index) {
                return _c("div", {
                  key: index + "feature",
                  staticClass:
                    "hidden-m table__filler border-b-1 border-blue-default",
                  class: [
                    _vm.length === 1 && "!w-8/12",
                    _vm.length > 2 ? "w-3/12" : "w-4/12",
                    feature.fields.productKey !== _vm.activeProduct.key
                      ? "bg-white"
                      : "bg-blue-light",
                  ],
                })
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-wrap" },
        [
          _vm._l(_vm.featureGroup.fields.specsfeatures, function (feature, i) {
            return [
              _c("ProductFeatureLabel", {
                key: i + "feature-label",
                attrs: {
                  feature: feature,
                  length: _vm.length,
                  i: i,
                  specs: _vm.specs,
                  "expand-all": _vm.expandTooltip,
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.group, function (features, productIndex) {
                return [
                  _c(
                    "div",
                    {
                      key: i + productIndex,
                      staticClass:
                        "column px-gap py-1 m-0 flex items-start justify-center",
                      class: _vm.setColumns(
                        i,
                        productIndex,
                        features.fields.productKey
                      ),
                    },
                    [
                      features.fields.specfeatureGroup[_vm.index] &&
                      features.fields.specfeatureGroup[_vm.index].fields &&
                      features.fields.specfeatureGroup[_vm.index].fields
                        .specsfeatures[i] &&
                      features.fields.specfeatureGroup[_vm.index].fields
                        .specsfeatures[i].fields &&
                      features.fields.specfeatureGroup[_vm.index].fields
                        .specsfeatures[i].fields.featureContent
                        ? _c(
                            "div",
                            { staticClass: "wrapper__content" },
                            [
                              _c("RichTextRenderer", {
                                attrs: {
                                  document:
                                    features.fields.specfeatureGroup[_vm.index]
                                      .fields.specsfeatures[i].fields
                                      .featureContent,
                                  "node-renderers": _vm.renderNodes(),
                                  "mark-renderers": _vm.renderMarks(),
                                },
                              }),
                            ],
                            1
                          )
                        : _c("div", { staticClass: "text-center" }, [
                            features.fields.specfeatureGroup[_vm.index] &&
                            features.fields.specfeatureGroup[_vm.index]
                              .fields &&
                            features.fields.specfeatureGroup[_vm.index].fields
                              .specsfeatures[i] &&
                            features.fields.specfeatureGroup[_vm.index].fields
                              .specsfeatures[i].fields &&
                            features.fields.specfeatureGroup[_vm.index].fields
                              .specsfeatures[i].fields.featureExists === false
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "inline",
                                    attrs: {
                                      width: "16",
                                      height: "4",
                                      viewBox: "0 0 16 4",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        width: "16",
                                        height: "4",
                                        fill: "#C1C9D1",
                                      },
                                    }),
                                  ]
                                )
                              : features.fields.specfeatureGroup[_vm.index] &&
                                features.fields.specfeatureGroup[_vm.index]
                                  .fields &&
                                features.fields.specfeatureGroup[_vm.index]
                                  .fields.specsfeatures[i] &&
                                features.fields.specfeatureGroup[_vm.index]
                                  .fields.specsfeatures[i].fields &&
                                features.fields.specfeatureGroup[_vm.index]
                                  .fields.specsfeatures[i].fields
                                  .featureExists === true
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "inline",
                                    attrs: {
                                      width: "12",
                                      height: "12",
                                      viewBox: "0 0 12 12",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        cx: "6",
                                        cy: "6",
                                        r: "6",
                                        fill: "#00263E",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                    ]
                  ),
                ]
              }),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }